import React, {Component ,Fragment} from 'react';
import {compose} from 'redux';
import { connect } from "react-redux";
import {Formik } from 'formik';

import {Grid} from '@material-ui/core';
import {Check} from '@material-ui/icons'
import _ from 'lodash'
import moment from 'moment';

import { saveLoanProceedDealAssumptions } from "store/state/deal";

import {getLoanProceedAssumptions, getLoanProceedAssumptionsByDealId} from 'store/state/loan/loan';

import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import interestRateTypes from "constants/interestRateTypes";

import { PARALLEL_SHOCK, MARKET_EXPECTATIONS_SHOCK, TREASURIES } from "components/Calculators/Constants/Constants";
import {getConfigItemByParentId} from 'store/state/configItems';
import {INTEREST_RATE_TYPE, FLOATING_INDICES, FIXED_INDICES} from "constants/configItemParents";
import { setConfigItemListState } from "components/Global/Fields/util";

import FormSectionTitle from './FormSectionTitle';
import LoanAssumptionsSection from "./LoanAssumptionsSection";

import { TopParentGrid, ParentGrid, ActionButtons } from '../styles';
import {RadioInput, DatePicker} from 'components/Global/FastFormikMaterial';


const dispositionTypes = [{name: 'Sell', value: "sell"},{name: 'Refi', value: "refi"}];

class LoanProceedsForm extends Component {
    state = {
      interestRateTypes: [],
      floatingIndices: [],
      fixedIndices: [],
    }

    componentDidMount() {
      this.props.getLoanProceedAssumptions();
      this.props.getLoanProceedAssumptionsByDealId({dealId: this.props.dealId});
      this.props.getConfigItemByParentId({ id: INTEREST_RATE_TYPE });
      this.props.getConfigItemByParentId({ id: FLOATING_INDICES });
      this.props.getConfigItemByParentId({ id: FIXED_INDICES });
     }

    componentDidUpdate(prevProps) {
      if (this.props.configItems && this.props.configItems.configItemByParent) {
        setConfigItemListState(INTEREST_RATE_TYPE, "interestRateTypes", this);
        setConfigItemListState(FLOATING_INDICES, "floatingIndices", this);
        setConfigItemListState(FIXED_INDICES, "fixedIndices", this);
    }
     }


     createLoanProceedsRequestParameters = (values) => {
      const {
        UwRate,
        amortizationTerm,
        debtYield,
        dscr,
        futureCapRate,
        interestRateType,
        rateIndex,
        loanTerm,
        loanType,
        maxLTV,
        projectedNOI,
        shockType,
        shockValue,
        spread,
        treasuryRate,
        dateOfAction,
        action,
      } = values;
      
      const loanProceedsRequestParameters = {
        amortizationTerm,
        interestRateType,
        rateIndex,
        loanTerm,
        loanType,
        projectedNOI,
        shockType,
        shockValue,
        dscr,
        action,
      };
      


      loanProceedsRequestParameters.dealId =  this.props.dealId;
      loanProceedsRequestParameters.calculationDate = moment(loanProceedsRequestParameters.calculationDate).format("YYYY-MM-DD");
      loanProceedsRequestParameters.dateOfAction = dateOfAction; //no formatting needed
      
      if(futureCapRate) loanProceedsRequestParameters.futureCapRate = this.transformRate(futureCapRate);
      
      if(treasuryRate) loanProceedsRequestParameters.treasuryRate = this.transformRate(treasuryRate);
      if(spread) loanProceedsRequestParameters.spread = this.transformRate(spread);
      if(UwRate) loanProceedsRequestParameters.UwRate = this.transformRate(UwRate);
      
      if(maxLTV) loanProceedsRequestParameters.maxLTV = this.transformRate(maxLTV);
      if(debtYield) loanProceedsRequestParameters.debtYield = this.transformRate(debtYield);

      if(!loanProceedsRequestParameters.shockType) loanProceedsRequestParameters.shockType = MARKET_EXPECTATIONS_SHOCK;
  
      if(loanProceedsRequestParameters.shockType === PARALLEL_SHOCK && loanProceedsRequestParameters.shockValue && loanProceedsRequestParameters.shockValue !== 0)
        loanProceedsRequestParameters.shockValue *= 0.0001;
      else if(loanProceedsRequestParameters.shockType === MARKET_EXPECTATIONS_SHOCK)
        delete loanProceedsRequestParameters.shockValue;
      
      return loanProceedsRequestParameters;
    }

      createAmortizationConfig = (values) => {    
        return {
          "curve":values.curve,
          "interestRateType": values.interestRateType,
          "amortizationType": values.amortizationType
        }
      }

      transformRate = (val) => {
        return +val / 100;
      }

      resetLoanProceedAssumptions = (initialValues, formik) => {
        this.setLoanProceedAssumptions(initialValues, formik);
      }

      setLoanProceedAssumptions = (selectedItem, formik) => {
        if(this.props.loanProceedAssumptions || this.props.loanProceedAssumptions.length > 0){
          const foundloanProceedAssumptions = _.find(this.props.loanProceedAssumptions,  { "loanType": selectedItem.value, },) || {};

          formik.values.loanType = foundloanProceedAssumptions.loanType;
          
          formik.values.dscr = foundloanProceedAssumptions.minDSCR ? foundloanProceedAssumptions.minDSCR : "";;
          formik.values.maxLTV = foundloanProceedAssumptions.maxLTV ? foundloanProceedAssumptions.maxLTV * 100 : "";;
          formik.values.debtYield = foundloanProceedAssumptions.minDebtYield ? foundloanProceedAssumptions.minDebtYield * 100 : "";;
          
          formik.values.spread = foundloanProceedAssumptions.loanSpread ? foundloanProceedAssumptions.loanSpread * 100 : "";;
          formik.values.amortizationTerm = foundloanProceedAssumptions.amortization ? foundloanProceedAssumptions.amortization : "";
          
          formik.values.interestRateType = foundloanProceedAssumptions.rateTypeId;
          formik.values.rateIndex = foundloanProceedAssumptions.indexId;

          if(formik.values.interestRateType === "5813c493-4681-11e9-82f6-0242ac120002")
            formik.values.UwRate = foundloanProceedAssumptions.UwRate ? foundloanProceedAssumptions.UwRate * 100 : "";

          formik.values.loanTerm = foundloanProceedAssumptions.term ? foundloanProceedAssumptions.term : "";
        }
      }

      getDefaultDateOfAction = (deal) => {
        if(!deal || !deal.loans || deal.loans.length === 0) return null;        
        let availableLoans = deal.loans.filter(x=>!!x.maturityDate);
        if(availableLoans.length === 0) return null;
        let result = _.sortBy(availableLoans, "maturityDate")[0].maturityDate;        
        return moment(result).utc();
      }

      render(){
        const dealMaturity = this.props.deal2 ? this.getDefaultDateOfAction(this.props.deal2[this.props.dealId]) : null;
        const initialValues = {
          calculationDate: moment(),
            UwRate: "",
            amortizationTerm: "",
            debtYield: "",
            dscr: "",
            futureCapRate: "",
            interestRateType: interestRateTypes.FIXED,
            rateIndex: "",
            loanTerm: "",
            loanType: "",
            maxLTV: "",
            projectedNOI: "",
            shockType: MARKET_EXPECTATIONS_SHOCK,
            shockValue: "",
            spread: "",
            treasuryRate: this.props.yieldCurveResult,
            action: "sell",
            dealMaturity: dealMaturity,
            dateOfAction: "",
          }

          if(this.props.loanProceedAssumptionsForDeal) {
            const saved =  this.props.loanProceedAssumptionsForDeal;
            if(saved.UwRate) initialValues.UwRate   = saved.UwRate * 100;
            if(saved.amortization) initialValues.amortizationTerm   = saved.amortization;
            if(saved.indexId) initialValues.rateIndex   = saved.indexId;
            if(saved.loanSpread) initialValues.spread   = saved.loanSpread * 100;
            if(saved.loanType) initialValues.loanType   = saved.loanType;
            if(saved.maxLTV) initialValues.maxLTV   = saved.maxLTV * 100;
            if(saved.minDSCR) initialValues.dscr   = saved.minDSCR ;
            if(saved.minDebtYield) initialValues.debtYield   = saved.minDebtYield * 100;
            if(saved.rateTypeId) initialValues.interestRateType   = saved.rateTypeId;
            if(saved.term) initialValues.loanTerm   = saved.term;
            if(saved.action) initialValues.action = saved.action;
            if(saved.dateOfAction) initialValues.dateOfAction = new Date(saved.dateOfAction);
          }

        
        return (
            <Formik 
            initialValues={initialValues}
            enableReinitialize={true}
            validate={values => { 
              let errors ={};
              if(initialValues.dealMaturity && values.dateOfAction){
                const isAfterDealMaturity = moment(values.dateOfAction).isAfter(initialValues.dealMaturity);
                if(isAfterDealMaturity){
                  errors["dateOfAction"] = "Invalid Date; Date is beyond end of senior loan";
                }
              } 
              return errors; 
            }}
            onReset={(initialValues, form) => {
              form.resetForm(initialValues);
            }}
            onSubmit={(values,{setSubmitting}) => {
              let request = this.createLoanProceedsRequestParameters(values);
              this.props.saveLoanProceedDealAssumptions(request);
              setSubmitting(false);
            }}
            render={({values,errors,status,touched, isSubmitting,handleChange, handleBlur,handleSubmit, handleReset}) => (
                <Fragment>
                  <TopParentGrid container alignItems={"flex-end"} spacing={8} >
                      <Grid item xs={6}>
                      </Grid>
                      <Grid item xs={6}>
                        <ActionButtons item xs={12}>
                            <SecondaryButton onClick={handleReset}>Reset</SecondaryButton>
                            <SecondaryButton onClick={handleSubmit}><Check/>Save</SecondaryButton>
                        </ActionButtons>
                      </Grid>
                  </TopParentGrid>
                  <Grid item xs={12}><FormSectionTitle title="Asset Plans"/></Grid>
                  <ParentGrid container alignItems="center" spacing={8} style={{marginBottom: "20px"}}>
                  <DatePicker
                          label="Date of Action"
                          fieldName="dateOfAction"
                          />
                  <RadioInput 
                    fullWidth
                    label="Action"
                    options={dispositionTypes}
                    fieldName="action"
                  />
                  {dealMaturity && <>{`Your next Loan Maturity is ${moment(dealMaturity).format('MM/DD/YYYY')}`}</>}
                  </ParentGrid>

                  <TopParentGrid container alignItems="center" spacing={8} >
                      <Grid item xs={12}><FormSectionTitle title="Loan Proceeds Assumptions"/></Grid>
                  </TopParentGrid>
                  Please complete this section even if you intend to sell because it is used in other calculations.
                  <ParentGrid container alignItems="center" spacing={8}>
                    <LoanAssumptionsSection setLoanProceedAssumptions={this.setLoanProceedAssumptions} 
                                            interestRateTypes={this.state.interestRateTypes}
                                            floatingIndices={this.state.floatingIndices}
                                            fixedIndices={this.state.fixedIndices}/>
                  </ParentGrid>
              </Fragment>
            )}/>
            );
          }
        }


function mapStateToProps({testHarness, loan, configItems, deal}, ownProps) {
return {
          loanProceeds: testHarness.loanProceeds,
          loanProceedAssumptions: loan.loanProceedAssumptions,
          loanProceedAssumptionsForDeal: ownProps.dealId && loan.loanProceedAssumptionsForDeal ? loan.loanProceedAssumptionsForDeal[ownProps.dealId] : null,
          yieldCurveResult: _.get(testHarness, 'testData.yieldCurveResult', 0),
          configItems,
          deal2: deal,
        }
}
  
export default compose(
  connect(
    mapStateToProps,
    {
      saveLoanProceedDealAssumptions,
      getLoanProceedAssumptions,
      getLoanProceedAssumptionsByDealId,
      getConfigItemByParentId,
    }
    ))(LoanProceedsForm);
